// @flow
import jstz from 'jstimezonedetect';
import tzlookup from 'tz-lookup';

export const getUserTimezone = () => jstz.determine().name();

export const getTimezoneFromLatLong = (lat: number, lon: number) =>
  tzlookup(lat, lon);
